module.exports = __webpack_public_path__ + "static/fonts/ionicons.24712f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/ionicons.ttf?v=2.0.0
// module id = zLjH
// module chunks = 35